<!-- 模型类型模块 顶部 -->
<template>
  <div class="pretrain">
    <gat-head />
    <div class="category-model cannotLabel">
      <div class="category-model-inner">
        <div class="category-select">
          <div class="select-box">
            <span>模型类型：</span>
            <el-select
              v-model="modelTypeName"
              placeholder="请选择"
              @visible-change="dropdwonVisibleChange"
              @change="dropdwonChange"
              filterable
            >
              <el-option
                v-for="item in Options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                @mouseover.native="optMouseOver"
              >
              </el-option>
            </el-select>
          </div>
          <dl class="notes">
            <dt>{{ Comment.current + '：' }}</dt>
            <!-- :title="item.label" -->
            <dd>
              {{
                commentData.length > 0 &&
                  commentData.find((item) => item.label === Comment.current)
                    .comment
              }}
            </dd>
          </dl>
        </div>
        <div>
          <router-link class="go-to-dataset" :to="{ name: 'dataset-lobby' }">
            <i class="el-icon el-icon-right"></i>
            <span>前往数据集大厅</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="pretrain-main">
      <div class="pretrain-sidebar cannotLabel">
        <div
          class="nav-sidebar"
          v-for="(nav, nidx) in sidebarNavFiltered"
          :key="nav.name || nidx"
        >
          <!-- <div :class="['title', nav.active ? 'active' : '']">
            <i class="icon_box">
              <icon-base v-bind="Icons[nav.name]">
                <component :is="nav.icon"></component>
              </icon-base>
            </i>
            <span>{{ nav.label }}</span>
          </div> -->
          <ul :class="['nav-list', `ul-${nav.name}`]">
            <li
              v-for="(item, idx) in nav.items"
              :class="[
                'item',
                nav.active && nav.activeItem === item.name ? 'active' : '',
              ]"
              @click="activeSideNav(nav.name, item.name, item.redirect, idx)"
              :key="item.name || idx"
              v-show="!item.hidden"
            >
              <i class="icon-spot"></i>
              <span class="label">{{ item.label }}</span>
              <i class="icon-line"></i>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="pretrain-content"> -->
      <!-- <router-view></router-view> -->
      <!-- v-if="isRouterAlive" -->
      <router-view />
      <!-- </div> -->
    </div>
    <guide-tool :path="hashId"></guide-tool>
  </div>
</template>

<script>
import IconModelCenter from '@/components/icons/typography/ModelCenter'
import IconDataCenter from '@/components/icons/typography/DataCenter'
import PRETRAIN from '@/axios/pretrain/pretrain.js'
import GuideTool from '@/components/guide/GuideTool.vue'
export default {
  name: 'pretrain-base',
  components: { IconModelCenter, IconDataCenter, GuideTool },
  inject: ['reload'],
  // props: ["modelType"],
  data() {
    return {
      Comment: {
        dropdownSwitch: false,
        current: '图像分类',
      },
      modelTypeName: '图像分类',
      modelType: '1',
      ModelType: [],
      hashId: '',
      // ModelType: {
      //   Items: [],
      //   PageSize: 100,
      //   PageIndex: 1,
      //   total: 0
      // },
      Sidebar: {
        dataset: {
          name: 'dataset',
          label: '数据中心',
          active: true,
          activeItem: 'list',
          icon: 'IconDataCenter',
          items: [
            {
              name: 'list',
              label: '我的数据集',
              redirect: 'dataset-list',
            },
            // {
            //   name: 'create',
            //   label: '创建数据集',
            //   redirect: 'dataset-create',
            // },
            {
              name: 'label',
              label: '标注数据',
              redirect: 'dataset-label',
              hidden: true,
            },
            {
              name: 'classify',
              label: '图片分类',
              redirect: 'dataset-classify',
              hidden: true,
            },
            {
              name: 'categorization',
              label: '文本分类',
              redirect: 'dataset-categorization',
              hidden: true,
            },
            {
              name: 'annotation',
              label: '文本标注',
              redirect: 'dataset-annotation',
              hidden: true,
            },
            {
              name: 'audioCategorization',
              label: '音频分类',
              redirect: 'dataset-audioCategorization',
              hidden: true,
            },
            {
              name: 'audioAnnotation',
              label: '音频标注',
              redirect: 'dataset-audioAnnotation',
              hidden: true,
            },
          ],
        },
        model: {
          name: 'model',
          label: '模型中心',
          active: false,
          activeItem: 'list',
          icon: 'IconModelCenter',
          items: [
            {
              name: 'list',
              label: '我的模型',
              redirect: 'model-list',
            },
            // {
            //   name: 'create',
            //   label: '创建模型',
            //   redirect: 'model-operate',
            // },
            {
              name: 'training',
              label: '训练模型',
              redirect: 'model-operate',
            },
            {
              name: 'verify',
              label: '校验模型',
              redirect: 'model-operate',
            },
            {
              name: 'release',
              label: '发布模型',
              redirect: 'model-operate',
            },
          ],
        },
      },
      activeNav: null,
      Icons: {
        model: {
          iconName: '模型中心',
          viewBox: '0 0 20 23',
          width: '20',
          height: '23',
        },
        dataset: {
          iconName: '数据中心',
          viewBox: '0 0 20 20',
          width: '20',
          height: '20',
        },
      },
    }
  },
  computed: {
    token() {
      return this.$store.state.token
    },
    Options() {
      return this.ModelType.map((item) => {
        return {
          value: item.dictId,
          label: item.dictTypeDesc,
        }
      })
    },
    commentData() {
      return this.ModelType.map((item) => {
        return {
          value: item.dictId,
          label: item.dictTypeDesc,
          comment: item.dictContent,
        }
      })
    },
    sidebarNavFiltered() {
      var result = {},
        modelType = this.modelType ? this.modelType : 1,
        modelTypeItem = this.ModelType.find(
          // modelTypeItem = this.ModelType.Items.find(
          (item) => item.dictId === modelType
        ),
        exclude = (key) =>
          result.dataset.items.map((item) => {
            let nav = item

            if (nav.name === key && nav.hidden) {
              nav.hidden = false
            }

            return nav
          })

      // 数据不存在，提前返回
      if (!modelTypeItem) {
        return this.Sidebar
      }

      // 引用类型深拷贝，有数据为 0 时候可能会存在浏览器兼容性
      result = JSON.parse(JSON.stringify(this.Sidebar))

      // TODO:此处使用动态进行硬解码，后续添加模型分类会产生很大的维护性问题
      if (modelTypeItem.dictTypeDesc === '图像分类') {
        result.dataset.items = exclude('classify')
      } else if (modelTypeItem.dictTypeDesc === '物体检测') {
        result.dataset.items = exclude('label')
      } else if (modelTypeItem.dictTypeDesc === '文本分类') {
        result.dataset.items = exclude('categorization')
      } else if (modelTypeItem.dictTypeDesc === '文本标注') {
        result.dataset.items = exclude('annotation')
      } else if (modelTypeItem.dictTypeDesc === '音频分类') {
        result.dataset.items = exclude('audioCategorization')
      } else if (modelTypeItem.dictTypeDesc === '音频标注') {
        result.dataset.items = exclude('audioAnnotation')
      }
      return result
    },
  },
  watch: {
    $route(to, from) {
      this.reload()
      this.init()
    },
    token() {
      // TODO:获取模型类别
      this.getModelType()
    },
    Options() {
      this.dropdwonVisibleChange(false)
    },
    modelType(val) {
      if (val == 1) {
        this.modelTypeName = '图像分类';
      } else if (val == 2) {
        this.modelTypeName = '物体检测';
      } else if (val == 3) {
        this.modelTypeName = '文本分类';
      } else if (val == 4) {
        this.modelTypeName = '文本标注';
      } else if (val == 5) {
        this.modelTypeName = '音频分类';
      } else if (val == 6) {
        this.modelTypeName = '音频标注';
      }
    },
  },
  created() {
    this.init()
  },
  mounted() {
    // this.init();
  },
  methods: {
    // 页面初始化处理
    init() {
      var operate = this.$route.query.operate,
        routeName = this.$route.name.split('-'),
        navName = routeName[0],
        targetName = operate ? operate : routeName[1],
        idx = this.Sidebar[navName].items.findIndex(
          (item) => item.name === targetName
        ),
        modelType = this.$route.params.modeltype
      // debugger;
      // 由链接重置选项
      this.modelType = modelType ? modelType : 1

      // 激活左侧边栏
      this.activeSideNav(navName, targetName, null, idx)
      // window.scrollTo(0, 0);

      // 获取模型类别
      // TODO:后续登录系统补上需要做处理
      if (this.token) {
        this.getModelType()
      }
    },
    // 模型类别选中
    dropdwonChange(val) {
      this.modelType = val
      var name = this.$route.name,
        params = this.$route.params

      if (params.modeltype == val) {
        return
      }

      params.modeltype = this.modelType
      // this.$router.push({ name: name, params: params });
      this.$router.push({ name: 'pretrain', params: params })
    },
    // 模型分类选中下拉鼠标经过事件
    optMouseOver(evt) {
      var target = evt.target

      this.Comment.current = target.textContent
    },
    // 模型分类选中下拉回收后重置注释
    dropdwonVisibleChange(isVisible) {
      if (!isVisible && this.Options.length > 0) {
        // 重置模型注释
        this.Comment.current = this.Options.find(
          (item) => item.value === this.modelType
        ).label
      }
    },
    // 激活左侧栏选中
    activeSideNav(navName, targetName, redirect, idx) {
      var navItemName = this.Sidebar[navName].items[idx].name,
        nav,
        route = {}

      for (nav in this.Sidebar) {
        if (this.Sidebar[nav].name === navName) {
          this.Sidebar[nav].active = true
          this.Sidebar[nav].activeItem = navItemName
        } else {
          this.Sidebar[nav].active = false
        }
      }

      if (redirect) {
        route = {
          // TODO:还需要包含模型分类
          name: redirect,
          params: {
            type: this.modelType,
          },
        }

        if (
          redirect.indexOf('list') === -1 &&
          redirect.indexOf('dataset') === -1
        ) {
          route.query = {}
          route.query.operate = targetName
        }

        if (this.$route.name === route.name) {
          this.reload()
        }

        this.$router.push(route)
      }
    },
    // 获取模型类型数据
    getModelType() {
      PRETRAIN.getModelType().then((result) => {
        if (result.isSuccess || result.returnCode === 200) {
          this.ModelType = result.data
          this.getHashId()
        }
      })
    },
    getHashId() {
      let hashId = ''
      let Options = this.Options
      let modelType = this.modelType
      let label = ''
      Options.find((item) => {
        if (item.value == modelType) {
          label = item.label
        }
      })

      switch (label) {
        case '图像分类':
          hashId = 'img-classify'
          break
        case '物体检测':
          hashId = 'object-mark'
          break
        case '文本分类':
          hashId = 'text-classify'
          break
        case '文本标注':
          hashId = 'text-mark'
          break
        case '音频分类':
          hashId = 'audio-classify'
          break
        case '音频标注':
          hashId = 'audio-mark'
          break
        default:
          break
      }
      this.hashId = hashId
    },
  },
}
</script>

<style lang="scss" scoped>
$box_shadow: 0px 2px 6px 0px rgba(15, 15, 17, 0.05);

.pretrain {
  min-height: 100%;
  background-color: $background_normal_color;
  padding-top: 80px;
}
.category-model {
  border-bottom: 1px solid #d2d8e6;
  background-color: $background_content;
  font-size: $font_size;
  color: $font_333_color;
  .category-model-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    width: $page_width;
    margin: 0 auto;
    .category-select {
      display: flex;
      max-width: 80%;
      align-items: center;
      .select-box {
        min-width: 21.5em;
      }
      .el-select {
        width: 200px;
        margin: 0 25px 0 5px;
      }
      &::v-deep .el-icon-arrow-up:before {
        content: '\e78f';
      }
      &::v-deep .el-input__inner {
        height: 36px;
        line-height: 36px;
        color: $font_333_color;
        border-radius: 0;
      }
      &::v-deep .el-input__icon {
        height: 36px;
        line-height: 36px;
      }
      .notes {
        overflow: hidden;
        display: flex;
        align-items: center;
        height: 3em;
        dt {
          min-width: 5.15em;
          color: $bold_color;
          font-weight: bold;
        }
        dd {
          overflow: hidden;
          text-overflow: ellipsis;
          width: 50em;
          max-height: 100%;
          white-space: nowrap;
          // display: -webkit-box;
          // -moz-line-clamp: 2;
          // -webkit-line-clamp: 2;
          // -moz-box-orient: vertical;
          // -webkit-box-orient: vertical;
        }
      }
    }

    .go-to-dataset {
      color: #4c88ff;
      font-size: 14px;
      font-weight: bold;
      .el-icon-right {
        margin-right: 5px;
        font-weight: bold;
      }
    }
  }
}
.pretrain-main {
  // overflow: hidden;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: $page_width;
  padding-bottom: 40px;
  margin: 40px auto 0;
}
.pretrain-sidebar {
  width: 160px;
  height: 360px;
  box-shadow: $box_shadow;
  // border-radius: 10px;
  overflow: hidden;
  .nav-sidebar {
    // overflow: hidden;
    // padding-bottom: 10px;
    // margin-bottom: 10px;
    border-radius: 3px;
    // box-shadow: $box_shadow;
    background: $background_content;
    text-align: center;
    &:last-child {
      margin-bottom: 0;
    }
    .title {
      position: relative;
      height: 50px;
      font-size: $font_size_middle;
      line-height: 50px;
      // 动效
      @include transition;
      .icon_box {
        position: absolute;
        left: 13px;
        top: 13px;
        margin-right: 1em;
        line-height: 1;
        vertical-align: middle;
      }
      &.active {
        background-color: $active_color;
        color: $font_color_1st;
      }
    }
    .nav-list {
      .item {
        display: block;
        box-sizing: border-box;
        width: 100%;
        height: 60px;
        line-height: 60px;
        // border-left: 3px solid transparent;
        color: $font_333_color;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        // 动效
        @include transition;
        .label {
          display: inline-block;
          // width: 5em;
          width: 102px;
          text-align: left;
          padding-left: 10px;
          box-sizing: border-box;
        }
        .icon-spot {
          width: 10px;
          height: 10px;
          border: 1px solid #fff;
          border-radius: 50%;
          box-shadow: 0px 0px 2px 0px rgba(51, 51, 51, 0.7) inset, 0px 0px 6px 0px rgba(51, 51, 51, 0.7);
          margin-right: 15px;
          box-sizing: border-box;
        }
        &.active {
          // border-left-color: $active_color;
          // background-color: $active_color_2;
          color: $active_color;
          .label {
            width: 102px;
            height: 32px;
            border: 1px solid $bgc_btn_primary;
            border-radius: 8px;
            line-height: 32px;
          }
          .icon-spot {
            width: 12px;
            height: 12px;
            border: 2px solid $bgc_btn_primary;
            box-shadow: none;
            margin-right: 14px;
            margin-left: -1px;
          }
        }
        &:hover {
          // background-color: $active_color_2;
          color: $active_color;
        }
        .icon-line {
          width: 2px;
          height: 20px;
          box-shadow: 0px 0px 5px 0px rgba(51, 51, 51, 0.7);
          border-radius: 1px;
          position: absolute;
          bottom: -10px;
          left: 20.5px;
        }
      }
      &.ul-model {
        .item:last-child {
          .icon-line {
            display: none;
          }
        }
      }
    }
  }
  // .nav-model {
  //   box-shadow: $box_shadow;
  // }
  // .nav-data {
  //   box-shadow: $box_shadow;
  // }
}
.pretrain-sidebar + div {
  // background-color: $background_content;
  width: 1020px;
  max-width: 1020px;
  // margin-bottom: -99999px;
  // padding-bottom: 99999px;
}
</style>
